import { useNavigate } from "react-router-dom";
import { useLanguage } from "../../context/LanguageContext";
import { FiShoppingCart } from "react-icons/fi";
import { useUser } from "../../context/UserContext";
import LoginPopUp from "../../pages/login/LoginPopUp";

const Header = () => {
  const navigate = useNavigate();
  const { isAuth, trueShowLoginPopup,showLoginPopup  } = useUser();

  const { t } = useLanguage();

  return (
    <div className="bg-[#141C3A] py-8 md:py-4 relative block">
      <div className=" flex flex-col lg:flex-row justify-center py-[2px] lg:py-1 text-sm font-semibold gap-x-5 items-center gap-y-1 lg:gap-y-0">
        <p className="text-white text-xs lg:text-sm -ml-12 hidden lg:block">{t("header", "title")}</p>
        <div className=" flex absolute right-3 xl:right-10 mt-[2px]">
          <div className="bg-[#FFC633] flex items-center px-2 py-[2px]">
            <FiShoppingCart size={16} />
            <button
              onClick={() => navigate("/supplier-application-form")}
              className="bg-[#FFC633] text-primary-color rounded hover:scale-90 transition-transform font-normal lg:font-bold px-5 text-[12px] ml-2 "
            >
              {t("header", "button")}
            </button>
          </div>

          {!isAuth && <button
             onClick={() => {
              if (isAuth == false) {
                trueShowLoginPopup();
              }
            }}
            className="bg-[#FFC633] text-primary-color hover:scale-90 transition-transform font-normal lg:font-bold px-5 text-[12px] ml-2  py-[2px]"
          >
            {t("header", "button2")}
          </button>}
        </div>
      </div>

      {showLoginPopup && (
        <div className="z-50">
          <LoginPopUp />
        </div>
      )}
    </div>
  );
};
export default Header;
